export default class Relationship {
  constructor(modelName) {
    this.modelName = modelName
    this.type = null
  }
}
